import * as React from 'react';

import classnames from 'classnames';
import MiniBetslip from '~/components/betslip/components/mini-betslip';
import { useServicesContext } from '~/providers/services-context';
import {
  TRACKING_ACTIONS,
  TRACKING_CATEGORIES,
  TRACKING_EVENTS } from
'~/services/actions/tracking-actions';
import { BETSLIP_OPEN, CONFIGDATA, NAVDATA } from '~/stores/constants';
import { REPUBS, type Repub } from '@cx-modules/constants';
import INavigationLink from '../../interfaces/navigation-link';
import useStore from '../../store';
import Icon from '~/components/icon';
import Link from '~/components/link';
import AllSportsMenu from './components/all-sports-menu';
import styles from './style/bottom-navigation.module.css';
import type INavData from '../../interfaces/config/nav';

interface IProps {
  navData: INavData;
  repub: Repub;
}

const BottomNavigation: React.FC<IProps> = ({ navData, repub }) => {
  const [allSportsOpenBottom, setShowAllSportsBottom] = useStore(
    ({ showAllSportsBottom, setShowAllSportsBottom }) => [
    showAllSportsBottom,
    setShowAllSportsBottom]

  );
  const betslipOpen = useStore((state) => state[BETSLIP_OPEN]);
  const bottomNav = useStore((state) => state[NAVDATA].bottomNav);
  const freeBetsCount = useStore((state) => state[CONFIGDATA].freeBetOffers);
  const casinoOffersCount = useStore((state) => state[CONFIGDATA].casinoOffers);
  const otherOffersCount = useStore((state) => state[CONFIGDATA].otherOffers);
  const setNavItem = useStore((state) => state.setNavItem);

  React.useEffect(() => {
    repub === REPUBS.CO.name &&
    setNavItem('Picks', 'Pronósticos', 'pronosticos');
  }, [repub]);

  const { labelActions, trackingActions } = useServicesContext();
  const openCloseSportsMenu = (): void => {
    setShowAllSportsBottom(!allSportsOpenBottom);
  };

  const handleMenuClick = (label: string): void => {
    if (label) {
      trackingActions.eventTracking({
        event: TRACKING_EVENTS.BOTTOM_NAVIGATION,
        eventCategory: TRACKING_CATEGORIES.NAVIGATION,
        eventAction: TRACKING_ACTIONS[TRACKING_EVENTS.BOTTOM_NAVIGATION],
        eventLabel: label
      });
    }
  };

  const handleAllSportsButtonClick = (): void => {
    openCloseSportsMenu();
    handleMenuClick(labelActions.get('ALL_SPORTS'));
  };

  const renderOfferCount = (item: INavigationLink) => {
    switch (item.url) {
      case 'free-bets':
      case 'bonus-bets':
        return freeBetsCount ?
        <span className={styles.offerCount}>{freeBetsCount}</span> :
        null;
      case 'casino':
        return casinoOffersCount ?
        <span className={styles.offerCount}>{casinoOffersCount}</span> :
        null;
      case 'free-bets/super-bowl':
        return otherOffersCount ?
        <span className={styles.offerCount}>{otherOffersCount}</span> :
        null;
      default:
        return null;
    }
  };

  const renderNavLink = (item: INavigationLink, index: number): JSX.Element => {
    const [icon, dimension = '20'] = (item.icon || '').split(',');

    return (
      <Link
        key={index}
        to={item.url}
        className={classnames(
          styles.menuItem,
          item.isSelected ? styles.active : ''
        )}
        preCallback={() => handleMenuClick(item.text)}>

				{icon &&
        <span className={styles.iconContainer}>
						<Icon
            icon={icon}
            height={parseInt(dimension, 10)}
            width={parseInt(dimension, 10)} />

						{renderOfferCount(item)}
					</span>
        }
				{item.text}
			</Link>);

  };

  const renderBetslipButton = (index: number) => {
    return (
      <div
        key={index}
        className={classnames(
          styles.menuItem,
          betslipOpen ? styles.active : ''
        )}
        onClick={() => handleMenuClick(labelActions.get('BETSLIP'))}>

				<span className={styles.iconContainer}>
					<MiniBetslip iconColour="Black" />
				</span>
				{labelActions.get('BETSLIP')}
			</div>);

  };

  const renderAllSportsButton = (index: number) => {
    return (
      <button
        key={index}
        id="all-sports-button"
        className={classnames(
          styles.menuItem,
          allSportsOpenBottom ? styles.active : ''
        )}
        onClick={handleAllSportsButtonClick}>

				<span className={styles.iconContainer}>
					<Icon icon="AmericanFootball" height={20} width={20} />
				</span>
				{labelActions.get('ODDS')}
			</button>);

  };

  return (
    <>
			<div className={styles.bottomNavigationWrapper} data-testid="bottom-nav">
				<div
          className={classnames(
            styles.bottomNavigation,
            allSportsOpenBottom ? styles.open : ''
          )}>

					{bottomNav.map((item: INavigationLink, index: number) => {
            switch (item.text) {
              case 'Betslip':
                return renderBetslipButton(index);
              case 'AZ Sports':
                return renderAllSportsButton(index);
              default:
                return renderNavLink(item, index);
            }
          })}
				</div>
			</div>
			<AllSportsMenu navData={navData} />
			<div
        className={classnames(styles.backdrop, {
          [styles.off]: !allSportsOpenBottom
        })} />

		</>);

};

export default BottomNavigation;